// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const LazyImage = require('client-v2/common/components/lazy-image')
const tag = require('client-v2/common/utils/hyperscript')
const CollectionModelRecord = require('client-v2/common/models/collection/record')
const UserModelRecord = require('client-v2/common/models/user/record')

const bem = BemEntity('ShareModalMinimalContent')

function ShareModalCollectionContent(props) {
  const { model } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('content')
      },
        model.type === 'mix' ?
        tag(CollectionDetails, { collection: model }) :
        tag(UserDetails, { user: model })
      )
    )
  )
}

ShareModalCollectionContent.propTypes = {
  className: PropTypes.string,
  model: PropTypes.oneOfType([
    PropTypes.shape(CollectionModelRecord.propTypes),
    PropTypes.shape(UserModelRecord.propTypes)
  ])
}

module.exports = ShareModalCollectionContent

function CollectionDetails({ collection }) {
  return ([
    tag(LazyImage, {
      className: bem.element('image'),
      sources: collection.images
    }),
    tag('div', {
      className: bem.element('details')
    },
      tag('div', {
        className: bem.element('username')
      },
        'By @' + collection.username
      ),
      `${collection.name}, a collection on Mix.com`
    )
  ])
}

function UserDetails({ user }) {
  return ([
    tag(LazyImage, {
      className: bem.element('image'),
      sources: [ user['photo_url'] ]
    }),
    tag('div', {
      className: bem.element('details')
    },
      tag('div', {
        className: bem.element('username')
      },
        '@' + user.username
      ),
      `${user['display_name']} on Mix.com`
    )
  ])
}
